import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-independence-day',
  templateUrl: './independence-day.component.html',
  styleUrls: ['./independence-day.component.scss']
})
export class IndependenceDayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
